export class DeviceDetail 
{
    id         		 : number;
    type             : number;
    deviceName       : string;
    counterName      : string;
    configurationJson: string;
    logoId    		 : number;
    ticketId         : number;
    promoId          : number;
    openingCalendarId: number;
    beep             : number;
    speech           : number;
    speechMessage    : string;
    speechCounter    : string;
    dateLicensed     : string;
    open             : number;
    notes   		 : string;
    enabled          : number;
}